/* ════════════════════════════════════════════════════════════════════
   Collection card quick-actions: color-swatch hover/click + direct ATC
   Event-delegated (document-level) so it works for AJAX-rendered cards
   (facet filtering re-renders #ProductGridContainer via innerHTML).
   Mirrors the proven delegation pattern used for the PDP add-to-cart.
   ════════════════════════════════════════════════════════════════════ */

(function () {
  function getCard(el) {
    return el.closest('.card-wrapper') || el.closest('.card');
  }

  function getMainImg(card) {
    return card ? card.querySelector('.card__media .media:first-of-type img') : null;
  }

  function setAtcAvailability(wrapper, available) {
    var btn = wrapper.querySelector('.card-quick-actions__atc');
    if (!btn) return;
    var label = btn.querySelector('.card-quick-actions__atc-label');
    if (available === 'false') {
      btn.disabled = true;
      if (label) label.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    } else {
      btn.disabled = false;
      if (label) label.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    }
  }

  /* Vind het actieve cart-UI element (notification of drawer) */
  function getCartComponent() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  /* ── Hover (preview): swap card image + sync ATC target variant ── */
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.card-quick-actions__swatch');
    if (!swatch || swatch.disabled) return;

    var wrapper = swatch.closest('[data-card-quick-actions]');
    if (!wrapper) return;

    wrapper.querySelectorAll('.card-quick-actions__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    var variantInput = wrapper.querySelector('.card-quick-actions__variant-id');
    if (variantInput && swatch.dataset.variantId) {
      variantInput.value = swatch.dataset.variantId;
    }
    setAtcAvailability(wrapper, swatch.dataset.available);

    var card = getCard(swatch);
    var mainImg = getMainImg(card);
    if (!mainImg) return;

    if (!mainImg.dataset.originalSrc) {
      mainImg.dataset.originalSrc = mainImg.currentSrc || mainImg.src;
      mainImg.dataset.originalSrcset = mainImg.srcset || '';
    }

    var imageUrl = swatch.dataset.variantImage;
    var imageUrl2x = swatch.dataset.variantImage2x;
    if (!imageUrl) return;

    mainImg.src = imageUrl;
    if (imageUrl2x) {
      mainImg.srcset = imageUrl + ' 533w, ' + imageUrl2x + ' 1066w';
    }
  });

  /* ── Leave the whole quick-actions area: restore default image + variant ── */
  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest('[data-card-quick-actions]');
    if (!wrapper) return;

    var related = e.relatedTarget;
    if (related && wrapper.contains(related)) return;

    var card = getCard(wrapper);
    var mainImg = getMainImg(card);
    if (mainImg && mainImg.dataset.originalSrc) {
      mainImg.src = mainImg.dataset.originalSrc;
      mainImg.srcset = mainImg.dataset.originalSrcset || '';
    }

    var defaultSwatch = wrapper.querySelector('.card-quick-actions__swatch[data-is-default="true"]');
    wrapper.querySelectorAll('.card-quick-actions__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    if (defaultSwatch) {
      defaultSwatch.classList.add('is-active');
      var variantInput = wrapper.querySelector('.card-quick-actions__variant-id');
      if (variantInput) {
        variantInput.value = defaultSwatch.dataset.variantId;
      }
      setAtcAvailability(wrapper, defaultSwatch.dataset.available);
    }
  });

  /* ── Click a swatch in the desktop hover overlay: navigate to the PDP for that variant ── */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card-quick-actions__swatch');
    if (!swatch) return;
    if (!swatch.closest('[data-card-quick-actions]')) return;

    if (swatch.disabled) {
      e.preventDefault();
      return;
    }
    var url = swatch.dataset.variantUrl;
    if (url) {
      window.location.href = url;
    }
  });

  /* ── Mobile "+" FAB: toggle the swatch/ATC popup ── */
  document.addEventListener('click', function (e) {
    var fab = e.target.closest('.card-mobile-fab');
    if (fab) {
      var wrap = fab.closest('[data-card-mobile-fab-wrap]');
      var popup = wrap ? wrap.querySelector('[data-card-mobile-fab-popup]') : null;
      if (!popup) return;

      var isOpen = !popup.hasAttribute('hidden');
      document.querySelectorAll('[data-card-mobile-fab-popup]').forEach(function (p) {
        if (p !== popup) {
          p.setAttribute('hidden', '');
          var btn = p.closest('[data-card-mobile-fab-wrap]')?.querySelector('.card-mobile-fab');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        popup.setAttribute('hidden', '');
        fab.setAttribute('aria-expanded', 'false');
      } else {
        popup.removeAttribute('hidden');
        fab.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (!e.target.closest('[data-card-mobile-fab-wrap]')) {
      document.querySelectorAll('[data-card-mobile-fab-popup]:not([hidden])').forEach(function (p) {
        p.setAttribute('hidden', '');
        var btn = p.closest('[data-card-mobile-fab-wrap]')?.querySelector('.card-mobile-fab');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Click a swatch in the mobile "+" popup: add that variant to cart directly ── */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card-quick-actions__swatch');
    if (!swatch) return;
    var popup = swatch.closest('[data-card-mobile-fab-popup]');
    if (!popup) return;

    if (swatch.disabled) return;

    var form = popup.querySelector('form');
    var variantInput = popup.querySelector('.card-quick-actions__variant-id');
    if (!form || !variantInput || !swatch.dataset.variantId) return;

    variantInput.value = swatch.dataset.variantId;

    popup.querySelectorAll('.card-quick-actions__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  /* ── Add to cart: AJAX submit, no page navigation ── */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches('[data-type="add-to-cart-form"]')) return;
      var btn = form.querySelector('.card-quick-actions__atc');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');

      var cartComponent = getCartComponent();
      var formData = new FormData(form);

      // Vraag de juiste sections op bij het actieve cart-element (notification of drawer)
      if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
        var sectionIds = cartComponent
          .getSectionsToRender()
          .map(function (s) { return s.id; });
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');

          if (response.status) {
            btn.classList.add('is-error');
            setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
            return;
          }

          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);

          // Open de cart-notification of cart-drawer met de nieuwe cart-inhoud
          if (cartComponent && response.sections) {
            if (typeof cartComponent.renderContents === 'function') {
              cartComponent.renderContents(response);
            }
          }

          // Sluit de mobile FAB popup na succes
          var popup = form.closest('[data-card-mobile-fab-popup]');
          if (popup) {
            setTimeout(function () {
              popup.setAttribute('hidden', '');
              var btn2 = popup.closest('[data-card-mobile-fab-wrap]')?.querySelector('.card-mobile-fab');
              if (btn2) btn2.setAttribute('aria-expanded', 'false');
            }, 900);
          }

          // Update cart count bubble (blijft als extra vangnet staan)
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (b) {
            b.textContent = response.item_count;
          });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
        });
    },
    true
  );
})();